import type { FormValues } from '../../promotions/types';
import { applyBriefingValuesVersion, getCouponVisibilityError, COUPON_VISIBLE_KEY } from '../../shared/utils/briefingTemplateVersion';
import {
  normalizeCompreEGanheValues,
  validateCompreEGanheValues,
} from '../../promotions/utils/compreEGanheRules';

export function normalizeAgentValues(templateId: string, values: FormValues, briefingV4 = false): FormValues {
  if (briefingV4) values = applyBriefingValuesVersion(templateId, values, true);
  if (templateId !== 't3') return values;
  const normalized = normalizeCompreEGanheValues(templateId, values);
  const childCount = normalized.numeroCard === '1' ? Number(normalized.qtdCardsFilhos ?? 0) : 0;
  Object.keys(normalized).forEach((key) => {
    const child = key.match(/__child(\d+)$/);
    if (child && Number(child[1]) > childCount + 1) {
      delete normalized[key];
    }
  });
  if (normalized.numeroCard !== '1') delete normalized.qtdCardsFilhos;
  for (let childNumber = 2; childNumber <= Math.min(15, childCount) + 1; childNumber++) {
    normalized[`numeroCard__child${childNumber}`] = String(childNumber);
  }
  return normalized;
}

export function validateAgentValues(templateId: string, values: FormValues, briefingV4 = false): Record<string, string> {
  const errors = validateCompreEGanheValues(templateId, values);
  const visibilityError = getCouponVisibilityError(templateId, values, briefingV4);
  if (visibilityError) errors[COUPON_VISIBLE_KEY] = visibilityError;
  if (templateId !== 't3') return errors;
  const count = String(values.qtdCardsFilhos ?? '').trim();
  if (values.numeroCard === '1' && (!/^\d+$/.test(count) || Number(count) > 15)) {
    errors.qtdCardsFilhos = 'Informe a quantidade de cards filhos entre 0 e 15.';
  }
  return errors;
}

export function getAgentAnswerError(templateId: string, fieldKey: string, values: FormValues, briefingV4 = false): string | undefined {
  const errors = validateAgentValues(templateId, values, briefingV4);
  if (errors[fieldKey]) return errors[fieldKey];
  // A newly entered discount can expose a mismatch with an earlier title.
  if (/^valorDesconto(?:__child\d+)?$/.test(fieldKey)) {
    return errors.nomeExibicao || errors.nomePromo;
  }
  return undefined;
}
